import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-container" id="about">
      <h1 className="about-heading">About Us</h1>
      <hr className="heading-underline" />
      <table className="about-table">
        <tbody>
          <tr>
            <td>Company Name</td>
            <td>Tanaya Jewel Co. Ltd</td>
          </tr>
          <tr>
            <td>Representative Name</td>
            <td>Chintan Shah</td>
          </tr>
          <tr>
            <td>Location</td>
            <td>〒400-0836 318-10 Kosemachi, Kofu City, Yamanashi Prefecture, Japan</td>
          </tr>
          <tr>
            <td>TEL <br /> FAX</td>
            <td>055-288-0691 <br />
            055-288-0692
            </td>
          </tr>
          <tr>
            <td>Description of Business</td>
            <td>We source and trade high-quality diamonds and gemstones, offering rare, authentic stones for jewelers and collectors.</td>
          </tr>
          <tr>
            <td>Establishment</td>
            <td>2024</td>
          </tr>
         
          <tr>
            <td>Main Banks</td>
            <td>
    The Kofu Shinkin Bank - Minami Branch<br />
    Yamanashi Chuo Bank - Minami Branch
  </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default About;
